import React, { Component } from 'react';
import { Grid, Dropdown, Form, Segment, Button, Header, Divider, Icon } from 'semantic-ui-react';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import ConsumerHistory from './History';
import UpdateAddress from './UpdateAddress';
import { relationShip, state } from '../../utils/defaults';
import { getConsumerDetails, getConsumerAccounts, getConsumerHistory, putConsumerInfo, getConsumePayments } from '../../utils/rest';
import Loading from '../Loading';
import validation from '../../components/SimpleReactValidation';
import MessageBox from '../../ui/MessageBox';
class ViewAccount extends Component {
    constructor(props) {
        super(props);
        this.validator = validation();
        this.state = {
            disabled: true,
            message8: false,
            loading: false,
            consumerDemo: {
                conConsumerId: 0,
                conLastName: '',
                conFirstName: '',
                conSsn: '',
                coaAddress1: '',
                coaAddress2: '',
                coaLocality: '',
                coaRegion: '',
                coaPostalCode: '',
                cphPhone: '',
                coeEmployer: '',
                conComments: '',
                secondaryConsumers: []
            },
            consumerHistory: [],
            dialerHistory: [],
            consumerAccounts: [],
            paymentsHistory: [],
            resetData: null,
            open: []
        };
    }

    componentDidMount() {
        this.getConsumerInfo();
        this.getConsumerAccountsInfo();
        this.getConsumerPaymentsInfo();
        this.getConsumerHistoryInfo("consumer");
        this.getConsumerHistoryInfo("dialer");
    }

    getConsumerInfo = () => {
        this.setState((prevState, props) => {
            return { loading: true };
        }, () => {
            getConsumerDetails(this.props.params.id).then((response) => {
                if (response !== null && (response instanceof Object)) {
                    if (response.secondaryConsumers.length === 0) {
                        response.secondaryConsumers = [{
                            conConsumerId: 0,
                            conLastName: '',
                            conFirstName: '',
                            conSsn: '',
                            coaAddress1: '',
                            coaAddress2: '',
                            coaLocality: '',
                            coaRegion: '',
                            coaPostalCode: '',
                            cphPhone: '',
                            coeEmployer: ''
                        }]
                    }
                    this.setState({
                        consumerDemo: response,
                        resetData: response,
                        loading: false
                    })
                }
            }).catch((error) => {
                this.setState({
                    loading: false
                });
            });
        });
    }

    getConsumerHistoryInfo = (type) => {
        this.setState((prevState, props) => {
            return { loading: true };
        }, () => {
            getConsumerHistory(this.props.params.id, type).then((response) => {
                if (response !== null) {
                    if (type === "dialer") {
                        this.setState({
                            dialerHistory: response,
                            loading: false

                        })
                    } else {
                        this.setState({
                            consumerHistory: response,
                            loading: false
                        })
                    }
                }
            }).then((error) => {
                this.setState({
                    loading: false
                });
            });
        });
    }

    getConsumerAccountsInfo = () => {
        this.setState((prevState, props) => {
            return { loading: true };
        }, () => {
            getConsumerAccounts(this.props.items.currentCorporate,this.props.params.id).then((response) => {
                if (response !== null) {
                    this.setState({
                        consumerAccounts: response,
                        loading: false
                    })
                }
            }).then((error) => {
                this.setState({
                    loading: false
                });
            });
        });
    }

    getConsumerPaymentsInfo = () => {
        this.setState((prevState, props) => {
            return { loading: true };
        }, () => {
            getConsumePayments(this.props.items.currentCorporate, this.props.params.id).then((response) => {
                if (response !== null) {
                    this.setState({
                        paymentsHistory: response,
                        loading: false
                    })
                }
            }).then((error) => {
                this.setState({
                    loading: false
                });
            });
        });
    }

    handleChange = (e) => {
        this.setState({
            consumerDemo: {
                ...this.state.consumerDemo,
                [e.target.name]: e.target.value
            }
        })

    }

    handleChangeSelect = (evt, e) => {
        this.setState({
            consumerDemo: {
                ...this.state.consumerDemo,
                [e.name]: e.value
            }
        });
    }

    handleListChange = (idx) => (evt) => {
        const changedItems = this.state.consumerDemo.secondaryConsumers.map((item, sidx) => {
            if (idx !== sidx) return item;
            return { ...item, [evt.target.name]: evt.target.value };
        });
        this.setState({
            consumerDemo: {
                ...this.state.consumerDemo,
                secondaryConsumers: changedItems
            }
        });
    }

    handleListChangeSelect = (idx) => (evt, e) => {
        const changedItems = this.state.consumerDemo.secondaryConsumers.map((item, sidx) => {
            if (idx !== sidx) return item;
            return { ...item, [e.name]: e.value };
        });
        this.setState({
            consumerDemo: {
                ...this.state.consumerDemo,
                secondaryConsumers: changedItems
            }
        });
    }

    open(index) {
        let open = this.state.open.slice();
        open[index] = true;
        this.setState({ open });
    }

    close(index) {
        let open = this.state.open.slice();
        open[index] = false;
        this.setState({ open });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            if (!this.state.disabled) {
                this.setState((prevState, props) => {
                    return { loading: true };
                }, () => {
                    putConsumerInfo(this.props.params.id, this.state.consumerDemo).then((response) => {
                        if (response !== null) {
                            this.setState({
                                loading: false,
                                message8: true,
                            });
                        }
                    }).then((error) => {
                        this.setState({
                            loading: false
                        });
                    });
                });

            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
            this.showError();
        }
    }
    showError = () => {
        this.setState({
            errorMessage: this.props._errorItems(this.removeNumber(this.validator.fields)),
            errorOpen: true
        })
    }
    removeNumber = (fields) => {
        let newFields = {};
        for (let key in fields) {
            let r = key.replace(/[0-9]/g, "");
            newFields[r] = fields[key];
        }
        return newFields;
    }
    render() {
        if (this.state.loading) {
            return (
                <Loading />
            )
        }
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="Account Management" child={[{ name: "Inquiry", url: "/inquiry" }, { name: "Account Details", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Form.Group>
                                    <Form.Field width={8} className="inline">
                                        <Button className="ui labeled left floated icon small button" onClick={(e) => { e.preventDefault(); this.setState({ disabled: false }) }}>
                                            <Icon className="pencil icon"></Icon>
                                            Edit Consumer Information
                                        </Button>
                                    </Form.Field>
                                    <Form.Field width={8}  className={this.state.disabled ? "accountManagement" : ""}>
                                        <Button.Group className="small right floated" >
                                            <Button onClick={(e) => { e.preventDefault(); this.setState({ consumerDemo: this.state.resetData }) }} >Undo Changes</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.handleSubmit}>Submit Changes</Button>
                                        </Button.Group>
                                    </Form.Field>
                                </Form.Group>
                                <Segment.Group raised  className={this.state.disabled ? "accountManagement" : ""}>
                                    <Segment inverted className="grey">
                                        <Header as="h4">Consumer Details</Header>
                                    </Segment>
                                    <Segment>
                                        <Form.Group>
                                            <Form.Field width={4} >
                                                <label>Last Name:</label>
                                                <Form.Input placeholder='Lastname' name="conLastName" value={this.state.consumerDemo.conLastName} onChange={this.handleChange} />
                                            </Form.Field>
                                            <Form.Field width={4}>
                                                <label>First Name:</label>
                                                <Form.Input placeholder='Firstname' name="conFirstName" value={this.state.consumerDemo.conFirstName} onChange={this.handleChange} />
                                            </Form.Field>
                                            <Form.Field width={4} >
                                                <label>{this.props.t("ssn")}:</label>
                                                <Form.Input name="conSsn" value={this.props._ifNull(this.state.consumerDemo.conSsn, "")} onChange={this.handleChange} placeholder='000000000' type="text" maxLength="9" />
                                                {this.validator.message('conSsn', this.state.consumerDemo.conSsn, 'SSN', false, { default: 'The SSN must be an integer.' })}
                                            </Form.Field>
                                            <Form.Field width={4}>
                                                <label>Phone:</label>
                                                <Form.Input placeholder='0000000000' name="cphPhone" value={this.props._ifNull(this.state.consumerDemo.cphPhone, "")} onChange={this.handleChange} type="text" maxLength="10" />
                                                {this.validator.message('cphPhone', this.state.consumerDemo.cphPhone, 'phone', false)}
                                            </Form.Field>
                                            <Form.Field width={4}>
                                                <label>Employer:</label>
                                                <Form.Input placeholder='Employer' name="coeEmployer" value={this.props._ifNull(this.state.consumerDemo.coeEmployer, "")} onChange={this.handleChange} />
                                            </Form.Field>
                                        </Form.Group>
                                    </Segment>

                                    {
                                        (() => {
                                            return this.state.consumerDemo.secondaryConsumers.map((item, index) => {
                                                if (item instanceof Object) {
                                                    return (
                                                        <Segment className="secondary" key={index}  className={this.state.disabled ? "accountManagement" : ""}>
                                                            <Header as="h4">Co-Guarantor {index + 1}</Header>
                                                            <Divider></Divider>
                                                            <Form.Group>
                                                                <Form.Field width={4}  >
                                                                    <label>Co-Guarantor Last Name:</label>
                                                                    <Form.Input placeholder='Lastname' name="conLastName" value={this.props._ifNull(item.conLastName, "")} onChange={this.handleListChange(index)} />
                                                                </Form.Field>
                                                                <Form.Field width={4}  >
                                                                    <label>Co-Guarantor First Name:</label>
                                                                    <Form.Input placeholder='Firstname' name="conFirstName" value={this.props._ifNull(item.conFirstName, "")} onChange={this.handleListChange(index)} />
                                                                </Form.Field>
                                                                <Form.Field width={4} >
                                                                    <label>{this.props.t("ssn")}:</label>
                                                                    <Form.Input placeholder='000000000' name="conSsn" value={this.props._ifNull(item.conSsn, "")} onChange={this.handleListChange(index)} type="text" maxLength="9" />
                                                                    {this.validator.message('conSsn', item.conSsn, 'SSN', false, { default: 'The SSN must be an integer.' })}

                                                                </Form.Field>
                                                                <Form.Field width={4}>
                                                                    <label>Phone:</label>
                                                                    <Form.Input placeholder='0000000000' name="cphPhone" value={this.props._ifNull(item.cphPhone, "")} onChange={this.handleListChange(index)} type="text" maxLength="10" />
                                                                    {this.validator.message('cphPhone', item.cphPhone, 'phone', false)}

                                                                </Form.Field>
                                                                <Form.Field width={4} >
                                                                    <label>Employer:</label>
                                                                    <Form.Input placeholder='Employer' name="coeEmployer" value={this.props._ifNull(item.coeEmployer, "")} onChange={this.handleListChange(index)} />
                                                                </Form.Field>
                                                                <Form.Field width={4} >
                                                                    <label>Relationship to Consumer:</label>
                                                                    <Dropdown className="fluid" placeholder='Select' search selection options={relationShip} name="ccmRelationShip" value={this.props._ifNull(item.ccmRelationShip, "")} onChange={this.handleListChangeSelect(index)}></Dropdown>
                                                                </Form.Field>
                                                            </Form.Group>
                                                            <Form.Group>
                                                                <Form.Field width={16} >
                                                                    <Button className="ui small button" onClick={this.open.bind(this, index)}>
                                                                        Update if Address Different from Consumer's
                                                                </Button>
                                                                </Form.Field>
                                                            </Form.Group>
                                                            <UpdateAddress i={index} address={item} {...this.props} open={this.state.open[index]} close={this.close.bind(this, index)} handleChangeSelect={this.handleListChangeSelect.bind(this, index)} handleChange={this.handleListChange.bind(this, index)} validator={this.validator} />
                                                        </Segment>
                                                    )
                                                }
                                                else {
                                                    return "";
                                                }
                                            })
                                        }
                                        )()}
                                </Segment.Group>
                                <Segment.Group raised  className={this.state.disabled ? "accountManagement" : ""}>
                                    <Segment inverted className="grey">
                                        <Header as="h4">Consumer Address</Header>
                                    </Segment>
                                    <Segment>
                                        <Form.Group>
                                            <Form.Field width={10}>
                                                <label>{this.props.t("address.street")}:</label>
                                                <Form.Input placeholder={this.props.t("address.street")} value={this.props._ifNull(this.state.consumerDemo.coaAddress1, "")} name="coaAddress1" onChange={this.handleChange} />
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <label>Apt / Suite Number:</label>
                                                <Form.Input placeholder='Apt / Suite Number' value={this.props._ifNull(this.state.consumerDemo.coaAddress2, "")} name="coaAddress2" onChange={this.handleChange} />
                                            </Form.Field>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Field width={6}>
                                                <label>Address (PO Box):</label>
                                                <Form.Input placeholder='Address (PO Box)' value={this.props._ifNull(this.state.consumerDemo.coaAddress2, "")} name="coaAddress2" onChange={this.handleChange} />
                                            </Form.Field>
                                            <Form.Field width={4}>
                                                <label>{this.props.t("city")}:</label>
                                                <Form.Input placeholder='City' value={this.props._ifNull(this.state.consumerDemo.coaLocality, "")} name="coaLocality" onChange={this.handleChange} />
                                            </Form.Field>
                                            <Form.Field width={3}>
                                                <label>{this.props.t("state")}:</label>
                                                <Dropdown className="fluid" placeholder='Select' search selection options={state} value={this.props._ifNull(this.state.consumerDemo.coaRegion, "")} name="coaRegion" onChange={this.handleChangeSelect}></Dropdown>
                                            </Form.Field>
                                            <Form.Field width={3}>
                                                <label>{this.props.t("zipcode")}:</label>
                                                <Form.Input placeholder={this.props.t("zipcode")} value={this.props._ifNull(this.state.consumerDemo.coaPostalCode, "")} name="coaPostalCode" onChange={this.handleChange} />
                                            </Form.Field>
                                        </Form.Group>
                                    </Segment>
                                </Segment.Group>
                                <Segment.Group raised  className={this.state.disabled ? "accountManagement" : ""}>
                                    <Segment inverted className="grey">
                                        <Header as="h4">Comments</Header>
                                    </Segment>
                                    <Segment>
                                        <Form.Group>
                                            <Form.Field width={16} >
                                                <label>Enter any comments below:</label>
                                                <Form.TextArea placeholder='Enter any comments below' value={this.props._ifNull(this.state.consumerDemo.conComments, "")} name="conComments" onChange={this.handleChange} />
                                            </Form.Field>
                                        </Form.Group>
                                    </Segment>
                                </Segment.Group>
                            </Form>
                            <ConsumerHistory {...this.props}
                                consumerHistory={this.state.consumerHistory && this.state.consumerHistory instanceof Array ? this.state.consumerHistory : []}
                                paymentsHistory={this.state.paymentsHistory && this.state.paymentsHistory instanceof Array ? this.state.paymentsHistory : []}
                                dialerHistory={this.state.dialerHistory && this.state.dialerHistory instanceof Array ? this.state.dialerHistory : []}
                                consumerAccounts={this.state.consumerAccounts && this.state.consumerAccounts instanceof Array ? this.state.consumerAccounts : []} />
                            <MessageBox {...this.props} size="mini" box={8} open={this.state.message8} close={() => { this.setState({ message8: false }) }} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}
export default ViewAccount;


// WEBPACK FOOTER //
// ./src/app/ui/accounts/ViewAccount.js